<template>
    <crud-create
        :open="open"
        :loading="loading"
        :title="title"
        :errorMessage="errorMessage"
        @create="create"
        @close="$emit('close')"
    >
        <deposito-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-create>
</template>

<script>
import DepositoProvider from "../../../providers/DepositoProvider";

import { CrudCreate } from "@dracul/common-frontend";
import ClientError from "@/errors/ClientError";

import DepositoForm from "../DepositoForm";

export default {
    name: "DepositoCreate",

    components: { DepositoForm, CrudCreate },

    props: {
        open: { type: Boolean, default: true },
    },

    data() {
        return {
            title: "deposito.creating",
            errorMessage: "",
            inputErrors: {},
            loading: false,
            form: {
                nombre: null,
                direccion: null,
                descripcion: null,
            },
        };
    },

    methods: {
        create() {
            if (this.$refs.form.validate()) {
                this.loading = true;
                DepositoProvider.createDeposito(this.form)
                    .then((r) => {
                        if (r) {
                            this.$emit("itemCreated", r.data.depositoCreate);
                            this.$emit("close");
                        }
                    })
                    .catch((error) => {
                        let clientError = new ClientError(error);
                        this.inputErrors = clientError.inputErrors;
                        this.errorMessage = clientError.i18nMessage;
                    })
                    .finally(() => (this.loading = false));
            }
        },
    },
};
</script>

<style scoped></style>

